<div class="row mt-4 mb-3 justify-content-center">
  <div class="col-xl-8 col-lg-10 col-md-12 col-sm-12">
    <app-searchbar></app-searchbar>

    <h4 class="text-center mt-3 pt-3 wow fadeIn" data-wow-duration="2s">
      Search in a database of {{ (stats?.total | number) || '' }} public observables to get an
      up-to-date and pertinent aggregated threat level<br />
      <small><a class="" routerLink="/how-it-works">see how it works</a></small>
    </h4>
  </div>
</div>


<div class="row mt-5 wow fadeIn justify-content-center">
  <h3 class="text-muted"><br />
    <hr />Recently added data</h3>
</div>
<div class="row mt-3 justify-content-center" *ngIf="stats?.recent?.categories">
    <div class="col-lg-3 py-2" *ngFor="let cat of stats.recent.categories | keyvalue: valueDescOrder">

      <app-stat-card bgColor="white" [fontColor]="'#fb6227'" [title]="cat.key.replaceAll('_', ' ').toUpperCase()" [titleColor]="'#212121'"
        [value]="cat.value">
      </app-stat-card>
    </div>
</div>